module.exports = "<p>\n  image-library works!\n</p>\n"